module.exports = __webpack_public_path__ + "img/26.bb1eca41.jpg";